import { render, staticRenderFns } from "./SiteEdit.vue?vue&type=template&id=23e54b26&scoped=true&"
import script from "./SiteEdit.vue?vue&type=script&lang=js&"
export * from "./SiteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e54b26",
  null
  
)

export default component.exports